var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"49","height":"45","viewBox":"0 0 49 45","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M29.9444 7.94118L0 45L21.7778 26.4706V37.0588L49 0L29.9444 15.8824V7.94118Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }